<template lang="pug">
.d-contents
  slot
</template>

<script>
const DIALOG_MAX_WIDTH = 400;

export default {
  name: 'DialogBase',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    portalKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {},
  created() {
    this.openDialog();
  },
  methods: {
    openDialog() {
      this.$dialogs.portal({
        attrs: {
          inputValue: this.portalKey,
          'max-width': DIALOG_MAX_WIDTH,
          title: 'Вход через Telegram',
        },
        listeners: {
          close: this.onDialogClose,
          'click:outside': this.onDialogClose,
        },
      });
    },
    onDialogClose() {
      this.inputValue = false;
    },
  },
};
</script>
